import { DeviceId } from 'shared/models';
import { useTranslation } from 'react-i18next';
import { useSetup } from 'hooks/useSetup/useSetup';
import { DeviceClassIcon } from '../deviceClassIcon/DeviceClassIcon';
import { useDeviceTypes } from 'hooks/useDeviceTypes/useDeviceTypes';
import { LoadingSpinner } from 'ui/shared/LoadingSpinner';
import { expandMacAddress } from 'util/cleanMacAddress';

require('./SetupDevice.css');

export type Props = {
    deviceId: DeviceId;
};

export const SetupDevice = ({ deviceId }: Props) => {
    const { t } = useTranslation();
    const { devices } = useSetup();
    const { deviceTypes, isLoadingDeviceTypes } = useDeviceTypes();

    const device = devices[deviceId];
    const deviceTypeId = device ? device.deviceTypeId : '';
    const deviceType = (deviceTypeId && deviceTypes && deviceTypes[deviceTypeId]) || null;

    if (!device) {
        return null;
    }

    return (
        <div
            id={ `setup-device-${deviceId}` }
            className="setup-device ui form"
        >
            <DeviceClassIcon
                size="small"
                deviceClass={ device.deviceClass }
            />
            
            <span
                className={ `setup-device-model${isLoadingDeviceTypes ? ' loading' : ''}` }
            >
                { deviceType ? deviceType.displayName : '...' }
                { isLoadingDeviceTypes && !deviceType &&
                    <LoadingSpinner size="tiny"/>
                }
            </span>
            <span className="setup-device-mac">
                { t('SETUP.MAC_', [ expandMacAddress(device.macAddress) ]) }
            </span>
        </div>
    );
};
